export const MY_OFFERS = 'https://my.cian.ru/my-offers/';

export const VK = 'https://vk.com/cian_pro';

export const TG = 'https://t.me/cian_realtor';

export const YT = 'https://www.youtube.com/channel/UCiT0aVQJwOj2eEvGAckXJjA';
